import { useState } from 'react';

import useDebounceCallback from '@lib/core/src/hooks/useDebounceCallback';
import { useQueryClient } from '@tanstack/react-query';

import { useAnalytics } from '@/analytics/useAnalytics';
import { CalendarMeetingDto, usePatchCalendarMeeting } from '@/api/generated';
import EditableMarkdown from '@/components/common/EditableTextMarkdown';

import { SectionContent } from './MeetingOverview/MeetingOverviewStyles';

interface MeetingBriefProps {
  brief: string;
  meeting: CalendarMeetingDto | undefined;
}

const MeetingBrief = ({ brief, meeting }: MeetingBriefProps) => {
  const { mutate: patchMeeting } = usePatchCalendarMeeting();
  const [localBrief, setLocalBrief] = useState(brief.split('Timeframes and Titles:')[0]); // TODO: remove this once we have a proper brief from backend
  const { captureEvent } = useAnalytics();
  const queryClient = useQueryClient();
  const handleEdit = (content: string) => {
    setLocalBrief(content);
  };

  const handleSave = () => {
    if (!meeting) return;
    patchMeeting(
      {
        id: meeting.id,
        data: {
          ...meeting,
          overview: {
            ...meeting.overview,
            brief: localBrief
          }
        }
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: ['getCalendarMeeting', meeting.id] });
          captureEvent('meeting_summary_edited', { meetingId: meeting.id });
        }
      }
    );
  };

  useDebounceCallback(localBrief, 400, handleSave);

  return (
    <SectionContent sx={{ marginTop: '40px' }}>
      <EditableMarkdown value={localBrief} callback={handleEdit} />
    </SectionContent>
  );
};

export default MeetingBrief;
